var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoffeepulsemid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4361,
    height: 2337,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 453,
    y: 649,
    width: 4361,
    height: 2337
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-453 -649)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2543 2526C2543 2375.66 2423.07 2253.14 2274.18 2249 2271.82 2249 2268.86 2249 2266.5 2249 2264.14 2249 2261.18 2249 2258.82 2249 2109.34 2253.14 1990 2375.66 1990 2526 1990 2679.3 2114.07 2803 2266.5 2803 2418.93 2803 2543 2679.3 2543 2526ZM2091.03 2526C2091.03 2428.93 2169.61 2350.21 2266.5 2350.21 2363.39 2350.21 2441.97 2428.93 2441.97 2526 2441.97 2623.07 2363.39 2701.79 2266.5 2701.79 2169.61 2701.79 2091.03 2623.07 2091.03 2526Z",
    fill: "#F3F3F3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390.45 2401.76C2459.01 2470.32 2459.01 2581.49 2390.45 2650.05 2321.88 2718.61 2210.72 2718.61 2142.16 2650.05 2073.59 2581.49 2073.59 2470.32 2142.16 2401.76 2210.72 2333.19 2321.88 2333.19 2390.45 2401.76Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#1930AB",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 83,
    transform: "matrix(1 0 0 1 503.363 1731)"
  }, "News Sentiment Meter :", /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 0,
    y: 127
  }, "A"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 68.75,
    y: 127
  }, "cumulative"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 466.927,
    y: 127
  }, "perspective on price "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 0,
    y: 226
  }, "trends of the day based on the news "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 0,
    y: 325
  }, "captured global")), /*#__PURE__*/React.createElement("path", {
    d: "M2907.31 1599C2761.7 1603.14 2644.51 1718.94 2638 1863.68 2638 1867.82 2638 1871.36 2638 1875.5 2638 1879.64 2638 1883.77 2638 1887.32 2644.51 2034.43 2765.85 2152 2915 2152 3068.3 2152 3192 2027.93 3192 1875.5 3192 1725.43 3071.85 1603.14 2922.69 1599 2920.33 1599 2917.37 1599 2915 1599 2912.63 1599 2910.27 1599 2907.31 1599ZM2975.96 1710.66C2977.15 1711.25 2978.92 1711.85 2980.11 1712.44 2983.07 1713.62 2985.43 1714.8 2987.8 1715.98 2990.17 1717.16 2993.13 1718.34 2995.5 1719.53 2997.86 1720.71 3000.23 1721.89 3003.19 1723.66 3005.56 1724.84 3007.93 1726.62 3010.29 1728.39 3012.66 1730.16 3015.03 1731.34 3017.4 1733.11 3019.76 1734.89 3022.13 1736.66 3023.91 1738.43 3026.27 1740.2 3028.05 1741.98 3030.42 1743.75 3067.71 1775.65 3091.38 1823.51 3091.38 1876.09 3091.38 1972.98 3012.66 2051.56 2915.59 2051.56 2818.52 2051.56 2739.8 1972.98 2739.8 1876.09 2739.8 1822.92 2763.48 1775.65 2800.77 1743.75 2803.13 1741.98 2804.91 1740.2 2807.28 1738.43 2809.65 1736.66 2812.01 1734.89 2813.79 1733.11 2816.16 1731.34 2818.52 1730.16 2820.89 1728.39 2822.07 1727.8 2823.26 1726.62 2824.44 1726.02 2827.99 1723.66 2831.55 1721.89 2835.69 1719.53 2838.06 1718.34 2841.02 1717.16 2843.38 1715.98 2865.28 1705.94 2890.14 1700.62 2915.59 1700.62 2936.31 1700.03 2957.02 1704.16 2975.96 1710.66Z",
    fill: "#F3F3F3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3040.33 1751.77C3108.89 1820.34 3108.89 1931.5 3040.33 2000.07 2971.76 2068.63 2860.6 2068.63 2792.03 2000.07 2723.47 1931.5 2723.47 1820.34 2792.03 1751.77 2860.6 1683.21 2971.76 1683.21 3040.33 1751.77Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2639.41 1864.27C2639.41 1864.27 2639.41 1863.68 2639.41 1863.68 2637.63 1801.04 2619.9 1741.94 2590.92 1691.11 2590.92 1691.11 2590.92 1691.11 2590.92 1691.11 2526.47 1578.24 2405.25 1502 2265.7 1502 2059.34 1502 1892 1669.25 1892 1875.5 1892 1877.27 1892 1878.45 1892 1880.23 1893.77 2017.93 1969.46 2137.3 2081.22 2200.54 2133.25 2230.09 2193.57 2247.82 2258.02 2249 2260.38 2249 2263.34 2249 2265.7 2249L2266.3 2249C2268.66 2249 2271.03 2249 2273.98 2249 2338.44 2247.82 2398.16 2230.09 2450.78 2200.54 2398.75 2170.99 2338.44 2153.26 2273.98 2152.08 2271.62 2152.08 2269.25 2152.08 2266.3 2152.08L2266.3 2152.08C2263.93 2152.08 2260.97 2152.08 2258.61 2152.08 2110.78 2147.94 1991.93 2027.97 1989.57 1880.23 1989.57 1878.45 1989.57 1877.27 1989.57 1875.5 1989.57 1722.44 2113.74 1598.92 2266.3 1598.92 2415.3 1598.92 2536.52 1716.53 2543.03 1863.68 2543.03 1863.68 2543.03 1863.68 2543.03 1863.68 2543.03 1867.82 2543.03 1871.36 2543.03 1875.5 2543.03 1877.27 2543.03 1878.45 2543.03 1880.23L2640 1880.23C2640 1878.45 2640 1877.27 2640 1875.5 2639.41 1871.95 2639.41 1867.82 2639.41 1864.27Z",
    fill: "#1930AB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2450.88 2200.5C2398.87 2170.93 2338.59 2153.18 2274.17 2152 2271.8 2152 2269.44 2152 2266.48 2152L2266.48 2249C2268.85 2249 2271.21 2249 2274.17 2249 2423.69 2253.14 2543.07 2375.57 2543.07 2525.8 2543.07 2678.39 2419.55 2802.59 2266.48 2802.59L2266.48 2802.59 2266.48 2802.59 2265.89 2802.59C2116.37 2802.59 1994.62 2683.71 1989.3 2535.26L1989.3 2535.26C1989.3 2532.3 1989.3 2528.75 1989.3 2525.8 1989.3 2522.84 1989.3 2519.29 1989.3 2516.33 1989.3 2515.74 1989.3 2515.15 1989.3 2514.56 1986.34 2417.56 1905.97 2341.26 1809.04 2341.26 1698.52 2341.26 976.901 2341.26 760 2341.26L760 2432.35 1810.81 2432.35C1856.32 2432.35 1893.56 2470.2 1892.37 2515.74L1892.37 2516.92C1892.37 2519.88 1892.37 2522.84 1892.37 2525.2 1892.37 2528.16 1892.37 2531.12 1892.37 2534.08 1894.15 2597.95 1911.29 2657.69 1940.84 2709.74 2005.26 2822.7 2126.41 2899 2265.89 2899L2266.48 2899 2266.48 2899 2266.48 2899C2472.74 2899 2640 2731.62 2640 2525.2 2640 2386.8 2563.76 2264.97 2450.88 2200.5Z",
    fill: "#01B4F0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2543 1225.5C2543 1364.97 2619.13 1486.12 2731.86 1550.54 2731.86 1550.54 2731.86 1550.54 2731.86 1550.54 2743.66 1557.63 2756.65 1563.54 2769.63 1569.45 2812.13 1587.77 2859.34 1598.41 2908.33 1599 2910.69 1599 2913.05 1599 2915.41 1599L2915.41 1502.08C2913.05 1502.08 2910.69 1502.08 2908.33 1502.08 2908.33 1502.08 2908.33 1502.08 2908.33 1502.08 2754.88 1497.94 2633.3 1368.52 2640.38 1212.5 2646.87 1070.07 2763.14 954.24 2905.38 948.921 2908.92 948.921 2912.46 948.921 2916 948.921L2916 852C2710.02 852 2543 1019.84 2543 1225.5Z",
    fill: "#1930AB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3380.47 1317.94C3330.22 1317.94 3290.61 1276.55 3290.61 1226.88L3290.61 1225.7C3290.61 1158.88 3272.88 1095.61 3242.14 1041.81 3178.29 928.869 3056.51 852 2917 852L2917 948.973C3069.52 948.973 3193.66 1073.14 3193.66 1225.7L3193.66 1225.7C3193.66 1238.71 3194.25 1251.72 3195.43 1264.13 3203.71 1346.32 3273.47 1409 3356.23 1409L4441 1409 4441 1317.94 3380.47 1317.94Z",
    fill: "#1930AB",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3100.88 1550.46C3100.88 1550.46 3100.88 1550.46 3100.88 1550.46 3066.02 1530.96 3028.19 1516.18 2987.42 1508.5 2966.73 1504.36 2946.05 1502 2924.18 1502 2921.82 1502 2918.86 1502 2916.5 1502L2916.5 1598.92C2918.86 1598.92 2921.23 1598.92 2924.18 1598.92 2924.18 1598.92 2924.18 1598.92 2924.18 1598.92 3073.11 1603.06 3193.08 1725.39 3193.08 1875.5 3193.08 1877.27 3193.08 1878.45 3193.08 1880.23 3190.71 2030.93 3067.79 2152.67 2916.5 2152.67 2767.57 2152.67 2646.42 2035.07 2639.92 1887.91 2639.92 1887.91 2639.92 1887.32 2639.92 1887.32 2639.92 1884.96 2639.92 1882.59 2639.92 1880.23L2543 1880.23C2543 1882.59 2543 1884.96 2543 1887.32 2543 1887.32 2543 1887.32 2543 1887.32 2544.77 1949.96 2562.5 2009.06 2591.46 2059.89 2591.46 2059.89 2591.46 2059.89 2591.46 2059.89 2655.88 2172.76 2777.03 2249 2916.5 2249 3121.57 2249 3287.63 2084.12 3290 1879.64L3290 1879.64C3290 1877.86 3290 1876.68 3290 1874.91 3290.59 1736.03 3214.35 1614.88 3100.88 1550.46Z",
    fill: "#01B4F0",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2274.18 2152.74C2419.52 2148.6 2536.5 2032.64 2543 1887.7 2543 1883.56 2543 1880.01 2543 1875.87 2543 1871.73 2543 1868.18 2543 1864.04 2536.5 1716.73 2415.39 1599 2266.5 1599 2113.48 1599 1990 1723.24 1990 1875.87 1990 2026.14 2109.94 2148.6 2258.82 2152.74 2261.18 2152.74 2264.14 2152.74 2266.5 2152.74 2268.86 2153.33 2271.23 2152.74 2274.18 2152.74ZM2091.03 1875.87C2091.03 1778.85 2169.61 1700.16 2266.5 1700.16 2363.39 1700.16 2441.97 1778.85 2441.97 1875.87 2441.97 1972.89 2363.39 2051.57 2266.5 2051.57 2169.61 2051.57 2091.03 1972.89 2091.03 1875.87Z",
    fill: "#F3F3F3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2390.53 1751.46C2459.09 1820.02 2459.09 1931.19 2390.53 1999.75 2321.97 2068.32 2210.8 2068.32 2142.24 1999.75 2073.67 1931.19 2073.67 1820.02 2142.24 1751.46 2210.8 1682.9 2321.97 1682.9 2390.53 1751.46Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2640 1225.5C2640 1375.57 2759.94 1497.86 2908.82 1502 2911.18 1502 2914.14 1502 2916.5 1502 2918.86 1502 2921.82 1502 2924.18 1502 3073.07 1497.86 3193 1375.57 3193 1225.5L3193 1225.5C3193 1073.07 3068.93 949 2916.5 949 2764.07 949 2640 1073.07 2640 1225.5ZM3091.97 1225.5C3091.97 1322.39 3013.39 1400.97 2916.5 1400.97 2819.61 1400.97 2741.03 1322.39 2741.03 1225.5 2741.03 1128.61 2819.61 1050.03 2916.5 1050.03 3013.39 1050.03 3091.97 1128.61 3091.97 1225.5Z",
    fill: "#F3F3F3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3040.41 1101.47C3108.97 1170.04 3108.97 1281.2 3040.41 1349.77 2971.84 1418.33 2860.68 1418.33 2792.11 1349.77 2723.55 1281.2 2723.55 1170.04 2792.11 1101.47 2860.68 1032.91 2971.84 1032.91 3040.41 1101.47Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2983.89 1315 2982.11 1315C2965.58 1315 2952 1301.42 2952 1284.9L2952 1224.1C2952 1207.58 2965.58 1194 2982.11 1194L2983.89 1194C3000.42 1194 3014 1207.58 3014 1224.1L3014 1284.9C3013.41 1301.42 3000.42 1315 2983.89 1315Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2940.77 1315 2886.24 1315C2851.86 1315 2824 1287.14 2824 1252.77L2824 1198.24C2824 1163.86 2851.86 1136 2886.24 1136L2940.77 1136C2975.14 1136 3003 1163.86 3003 1198.24L3003 1252.77C3003 1287.14 2975.14 1315 2940.77 1315Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2943.65 1301 2883.35 1301C2858.51 1301 2839 1280.84 2839 1256.53L2839 1195.47C2839 1170.57 2859.1 1151 2883.35 1151L2943.65 1151C2968.49 1151 2988 1171.16 2988 1195.47L2988 1255.94C2988 1280.84 2967.9 1301 2943.65 1301Z",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2961.82 1282 2924.18 1282C2917.71 1282 2913 1276.62 2913 1270.64L2913 1232.36C2913 1225.78 2918.29 1221 2924.18 1221L2961.82 1221C2968.29 1221 2973 1226.38 2973 1232.36L2973 1270.64C2973 1277.22 2968.29 1282 2961.82 1282Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2899.96 1237 2853.04 1237C2848.93 1237 2846 1234 2846 1229.8L2846 1229.2C2846 1225 2848.93 1222 2853.04 1222L2899.96 1222C2904.07 1222 2907 1225 2907 1229.2L2907 1229.8C2907 1234 2904.07 1237 2899.96 1237Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2899.96 1259 2853.04 1259C2848.93 1259 2846 1256 2846 1251.8L2846 1251.2C2846 1247 2848.93 1244 2853.04 1244L2899.96 1244C2904.07 1244 2907 1247 2907 1251.2L2907 1251.8C2907 1255.4 2904.07 1259 2899.96 1259Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2899.96 1281 2853.04 1281C2848.93 1281 2846 1278 2846 1273.8L2846 1273.2C2846 1269 2848.93 1266 2853.04 1266L2899.96 1266C2904.07 1266 2907 1269 2907 1273.2L2907 1273.8C2907 1278 2904.07 1281 2899.96 1281Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#5E5E5E",
    fontFamily: "Arial,Arial_MSFontService,sans-serif",
    fontWeight: 400,
    fontSize: 41,
    transform: "matrix(1 0 0 1 2851.39 1206)"
  }, "NEWS"), /*#__PURE__*/React.createElement("path", {
    d: "M2288 1850.45C2288 1855.21 2288 1859.96 2288 1864.72 2288.62 1864.72 2289.86 1864.72 2290.48 1864.72L2291.1 1879 2298.55 1879 2297.93 1864.72C2300.41 1864.72 2303.52 1865.32 2306 1865.32 2306 1860.56 2306 1855.8 2306 1851.04 2302.9 1850.45 2299.79 1850.45 2296.07 1850.45 2292.97 1849.85 2290.48 1849.85 2288 1850.45Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2226 1906C2230.86 1906 2236.32 1906 2241.18 1906 2241.79 1904.33 2242.39 1902.67 2243 1901 2237.54 1901 2232.68 1901 2227.21 1901 2226.61 1902.67 2226 1904.33 2226 1906Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2252 1924.57 2252 1917.71 2238.79 1917.71C2238.79 1916 2239.36 1913.71 2239.36 1912 2234.77 1912 2230.17 1912 2225.57 1912 2225 1914.86 2225 1917.71 2225 1920.57 2225 1922.86 2225 1925.71 2225.57 1928 2230.17 1928 2234.77 1928 2239.36 1928 2239.36 1926.86 2238.79 1925.71 2238.79 1924.57L2252 1924.57Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2282 1865.71C2282 1861 2282 1856.29 2282 1851 2277.33 1852.18 2272.67 1853.35 2268 1855.12 2268 1860.41 2268 1865.71 2268 1871 2272.67 1868.65 2277.33 1866.88 2282 1865.71Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2244.6 1871.51C2245.8 1871.51 2246.4 1871.51 2247 1872.68 2248.2 1873.86 2248.2 1875.62 2247 1876.79 2246.4 1877.38 2245.2 1877.97 2244 1877.97 2242.2 1877.97 2241 1877.97 2239.2 1877.97 2238 1879.73 2236.8 1881.49 2235.6 1883.25 2238.6 1883.25 2241 1883.25 2244 1883.25 2245.2 1883.25 2246.4 1883.25 2247 1884.43 2248.2 1885.6 2248.2 1887.37 2247 1888.54 2246.4 1889.13 2245.2 1889.13 2244 1889.13 2239.8 1889.13 2236.2 1889.13 2232 1889.13 2230.8 1890.89 2230.2 1893.24 2229 1895 2233.8 1895 2238.6 1895 2243.4 1895 2244 1895 2244.6 1895 2244.6 1895 2246.4 1891.48 2248.8 1887.95 2251.8 1884.43L2262 1893.83C2262 1890.3 2262 1887.37 2262 1883.84L2256.6 1879.14C2258.4 1877.38 2260.2 1876.21 2262 1875.03 2262 1869.16 2262 1863.87 2262 1858 2256 1861.52 2250 1866.22 2244.6 1871.51Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2311 1852C2311 1856.68 2311 1861.94 2311 1866.61 2319.34 1868.95 2327.08 1873.04 2333.04 1878.3L2322.91 1888.24 2328.27 1892.92 2338.4 1882.98C2346.74 1891.75 2352.1 1903.44 2352.69 1916.3L2338.4 1916.88 2338.4 1923.89 2352.69 1923.31C2352.69 1927.4 2352.1 1930.91 2350.91 1935L2365.8 1935C2366.99 1930.32 2366.99 1925.65 2366.99 1920.97 2367.59 1887.07 2343.76 1859.01 2311 1852ZM2353.29 1920.97 2353.29 1920.97C2353.29 1920.39 2353.29 1920.97 2353.29 1920.97 2353.29 1920.97 2353.29 1920.97 2353.29 1920.97Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2288.35 1904.99C2288.35 1906.16 2288.35 1907.91 2287.13 1909.09 2285.91 1910.26 2284.09 1910.26 2282.87 1909.09 2282.87 1909.09 2282.87 1909.09 2282.87 1908.5 2279.83 1911.43 2278 1915.53 2278 1919.63 2278 1922.56 2278.61 1925.49 2280.43 1927.24 2281.04 1927.24 2281.65 1927.83 2282.26 1927.83 2284.7 1928.41 2286.52 1929 2288.96 1929 2290.17 1929 2292 1928.41 2293.22 1928.41 2288.96 1927.83 2285.3 1924.31 2285.3 1919.63 2285.3 1914.94 2289.56 1910.84 2294.43 1910.84 2299.3 1910.84 2303.57 1914.94 2303.57 1919.63 2303.57 1919.63 2303.57 1919.63 2303.57 1920.21 2305.39 1916.7 2306 1912.6 2306 1909.09 2306 1902.06 2306 1895.03 2306 1888L2294.43 1903.81C2292 1903.81 2290.17 1903.81 2288.35 1904.99Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2302.35 1929.33C2298.82 1932.17 2294.12 1933.87 2290 1934.43 2291.18 1935 2292.94 1935 2294.12 1935 2302.94 1935 2310 1928.2 2310 1919.7 2310 1919.13 2310 1918.57 2310 1918 2310 1918.57 2309.41 1919.13 2309.41 1919.7 2307.65 1923.67 2305.29 1927.07 2302.35 1929.33Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2222.51 1906C2221.93 1906 2221.35 1906 2220.77 1906 2219.02 1906.6 2218.44 1909 2219.61 1910.8 2220.19 1912 2221.35 1912 2222.51 1912 2223.09 1912 2224.26 1912 2224.84 1912 2224.84 1910.2 2225.42 1907.8 2226 1906 2224.84 1906 2223.67 1906 2222.51 1906Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2219.15 1898.6C2219.15 1900.4 2220.96 1901 2222.17 1901 2223.97 1901 2225.78 1901 2227.59 1901 2228.19 1899.2 2228.8 1896.8 2230 1895 2227.59 1895 2224.58 1895 2222.17 1895 2219.76 1895 2218.55 1896.8 2219.15 1898.6Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2186.57 1830C2206.06 1830 2224.96 1830 2244.46 1830 2246.23 1830 2248 1828.8 2248 1827 2248 1825.2 2246.23 1824 2244.46 1824 2224.96 1824 2206.06 1824 2186.57 1824 2185.98 1824 2185.39 1824 2184.8 1824 2183.02 1824.6 2182.43 1827 2183.61 1828.8 2184.21 1830 2185.39 1830 2186.57 1830Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2206.73 1883C2200.18 1883 2193.64 1883 2187.09 1883 2185.31 1883 2183.52 1884.8 2184.12 1886.6 2184.12 1887.8 2185.9 1889 2187.09 1889 2193.64 1889 2199.59 1889 2206.13 1889 2207.32 1889 2208.51 1889 2209.11 1888.4 2210.3 1887.2 2210.3 1885.4 2209.11 1884.2 2209.11 1883 2207.92 1883 2206.73 1883Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2187.64 1900.85C2194.31 1900.85 2200.38 1900.85 2207.06 1900.85 2208.27 1900.85 2209.48 1900.85 2210.09 1900.26 2211.3 1899.09 2211.3 1897.34 2210.09 1896.17 2209.48 1895.58 2208.27 1895 2207.06 1895 2200.38 1895 2193.71 1895 2187.03 1895 2185.21 1895 2184 1896.75 2184 1898.51 2184.61 1900.26 2186.43 1901.43 2187.64 1900.85Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2187.09 1871.64C2185.31 1871.64 2183.52 1873.55 2184.12 1875.45 2184.12 1876.73 2185.9 1878 2187.09 1878 2193.64 1878 2199.59 1878 2206.13 1878 2207.32 1878 2208.51 1878 2209.11 1876.73 2210.3 1875.45 2210.3 1873.55 2209.11 1872.27 2208.51 1871.64 2207.32 1871 2206.13 1871 2200.18 1871.64 2193.64 1871.64 2187.09 1871.64Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2206.71 1908C2200.14 1908 2193.56 1908 2186.99 1908 2185.2 1908 2184 1909.8 2184 1911.6 2184 1912.8 2185.79 1914 2186.99 1914 2193.56 1914 2199.54 1914 2206.11 1914 2207.31 1914 2208.51 1914 2209.1 1913.4 2210.3 1912.2 2210.3 1910.4 2209.1 1909.2 2209.1 1908 2207.91 1908 2206.71 1908Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2194.47 1928.91C2192.09 1928.91 2190.31 1928.91 2187.94 1928.32 2182.6 1927.14 2177.86 1924.19 2175.49 1919.46 2173.71 1915.92 2173.12 1911.78 2173.12 1908.24 2173.12 1873.98 2173.12 1839.72 2173.12 1805.46 2202.77 1805.46 2232.42 1805.46 2262.07 1805.46 2262.07 1823.18 2262.07 1840.9 2262.07 1858.62 2263.85 1857.44 2266.22 1856.85 2268 1855.67 2268 1838.54 2268 1821.41 2268 1804.87 2268 1803.69 2268 1801.33 2266.81 1800.74 2265.63 1799.56 2264.44 1800.15 2262.66 1800.15 2232.42 1800.15 2202.17 1800.15 2171.34 1800.15 2170.15 1800.15 2168.37 1800.15 2167.19 1801.33 2166 1802.51 2166 1804.28 2166 1806.05 2166 1840.31 2166 1873.98 2166 1908.24 2166 1913.55 2166.59 1918.87 2168.97 1923.6 2171.93 1929.5 2177.86 1933.64 2184.38 1934.82 2186.76 1935.41 2189.13 1936 2192.09 1936 2203.36 1936 2214.03 1936 2225.3 1936 2224.71 1934.23 2224.71 1931.87 2224.12 1930.09 2215.22 1928.91 2204.55 1928.91 2194.47 1928.91Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2221.56 1883C2219.76 1883 2218.55 1884.8 2219.16 1886.6 2219.16 1888.4 2220.96 1889 2222.16 1889 2225.77 1889 2228.78 1889 2232.39 1889 2233.59 1887.2 2234.8 1884.8 2236 1883 2231.19 1883 2226.38 1883 2221.56 1883Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2244.14 1841C2245.33 1841 2246.52 1841 2247.11 1839.91 2248.3 1838.82 2248.3 1837.18 2247.11 1836.09 2245.92 1835 2244.14 1835 2242.96 1835 2223.97 1835 2204.98 1835 2186.58 1835 2185.99 1835 2185.4 1835 2184.8 1835 2183.02 1835.55 2182.43 1837.73 2183.62 1839.36 2184.21 1840.45 2185.4 1840.45 2186.58 1840.45 2205.57 1841 2225.16 1841 2244.14 1841Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2245.05 1860C2238.35 1860 2231.05 1860 2224.36 1860 2223.14 1860 2221.92 1860 2221.32 1860 2219.49 1860.6 2218.27 1863 2219.49 1864.8 2220.1 1866 2221.32 1866 2222.53 1866 2229.83 1866 2237.14 1866 2245.05 1866 2246.26 1866 2247.48 1866 2248.09 1864.8 2249.3 1863.6 2249.3 1861.8 2248.09 1860.6 2246.87 1860 2245.65 1860 2245.05 1860Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2221.91 1872C2220.16 1872 2219 1873.8 2219 1875.6 2219 1876.8 2220.74 1878 2221.91 1878 2227.72 1878 2232.95 1878 2238.77 1878 2240.51 1875.6 2242.26 1873.8 2244 1872 2244 1872 2243.42 1872 2243.42 1872 2236.44 1872 2229.47 1872 2221.91 1872Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2210.12 1860.2C2209.53 1859.6 2208.36 1859 2207.19 1859 2201.9 1859 2196.04 1859 2190.75 1859 2189.58 1859 2188.41 1859 2187.23 1859 2185.47 1859.6 2184.3 1862 2185.47 1863.8 2186.06 1865 2187.23 1865 2188.41 1865 2194.86 1865 2200.73 1865 2207.19 1865 2208.36 1865 2209.53 1865 2210.12 1863.8 2211.29 1863.8 2211.29 1861.4 2210.12 1860.2Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2283 1908.12C2284.11 1909.29 2285.78 1909.29 2286.89 1908.12 2288 1906.94 2288 1905.76 2288 1904 2285.78 1905.18 2284.11 1906.35 2283 1908.12 2283 1908.12 2283 1908.12 2283 1908.12Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2262 1894 2267 1888.71 2262 1884C2262 1887.53 2262 1890.47 2262 1894L2262 1894Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2243.97 1878C2245.21 1878 2246.45 1878 2247.07 1876.73 2248.31 1875.45 2248.31 1873.55 2247.07 1872.27 2246.45 1871.64 2245.21 1871 2244.59 1871 2242.72 1872.91 2240.86 1875.45 2239 1877.36 2240.86 1878 2242.72 1878 2243.97 1878Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2305 1850C2305 1854.92 2305 1859.85 2305 1864.77 2306.8 1865.38 2309.2 1865.38 2311 1866 2311 1861.08 2311 1855.54 2311 1850.62 2309.2 1850.62 2307.4 1850.62 2305 1850Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2243 1901C2243.6 1899.2 2244.8 1896.8 2246 1895 2245.4 1895 2244.8 1895 2244.8 1895 2240 1895 2235.2 1895 2230.4 1895 2229.8 1896.8 2228.6 1899.2 2228 1901 2232.8 1901 2237.6 1901 2243 1901Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2305.36 1908.06C2305.36 1911.6 2304.75 1915.73 2302.94 1919.26 2302.94 1923.98 2298.72 1927.52 2293.89 1927.52 2293.28 1927.52 2293.28 1927.52 2292.68 1927.52 2291.47 1928.11 2289.66 1928.11 2288.45 1928.11 2286.04 1928.11 2283.62 1927.52 2281.81 1926.93 2281.21 1926.93 2280.6 1926.34 2280 1926.34 2282.42 1929.87 2285.43 1932.82 2290.26 1934 2295.09 1933.41 2299.32 1931.64 2302.94 1928.69 2305.96 1926.34 2308.98 1922.21 2310.19 1918.67 2310.19 1918.08 2310.79 1917.49 2310.79 1916.91 2310.19 1913.96 2308.98 1911.01 2307.17 1908.65L2312 1882.13C2312 1880.95 2312 1879.18 2312 1878L2305.96 1886.25C2305.36 1894.51 2305.36 1900.99 2305.36 1908.06Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2262 1875C2263.8 1873.85 2266.2 1872.12 2268 1871.55 2268 1866.36 2268 1861.18 2268 1856 2266.2 1856.58 2263.8 1857.73 2262 1858.88 2262 1864.06 2262 1869.24 2262 1875Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2225 1912C2229.92 1912 2234.85 1912 2239.77 1912 2240.38 1910.2 2240.38 1907.8 2241 1906 2236.08 1906 2230.54 1906 2225.62 1906 2225.62 1908.4 2225 1910.2 2225 1912Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2244.08 1889C2245.28 1889 2245.89 1889 2247.09 1888.4 2248.3 1887.2 2248.3 1885.4 2247.09 1884.2 2246.49 1883.6 2245.28 1883 2244.08 1883 2241.06 1883 2238.64 1883 2235.62 1883 2234.42 1884.8 2233.21 1887.2 2232 1889 2236.23 1889 2240.45 1889 2244.08 1889Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2288 1864.22C2288 1859.48 2288 1854.74 2288 1850 2286.5 1850 2284.5 1850.59 2283 1851.19 2283 1855.93 2283 1860.67 2283 1866 2284.5 1864.82 2286 1864.82 2288 1864.22Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2225 1929C2225 1930.8 2225.59 1933.2 2226.19 1935 2230.93 1935 2236.26 1935 2241 1935 2240.41 1933.2 2239.81 1930.8 2239.81 1929 2234.48 1929 2229.74 1929 2225 1929Z",
    fill: "#5E5E5E",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.575 130.16C112.774 129.689 101.394 128.688 92.2658 127.864 83.1375 127.04 75.4321 126.216 75.1357 126.04 74.8393 125.922 57.5906 108.912 36.7262 88.3115 10.4682 62.3552-1.26832 50.5835-1.44599 49.9364-1.56468 49.4064-1.56468 48.5824-1.44599 48.0528-1.20897 46.9935 46.5065-0.387349 47.87-0.916989 48.344-1.09377 49.1738-1.09377 49.7665-0.975917 50.5962-0.79949 59.3688 7.67619 88.5314 36.5753 109.277 57.117 126.467 74.2445 126.704 74.7155 127 75.1862 128.126 84.898 129.668 100.319 131.09 113.974 132.275 125.627 132.394 126.275 132.69 127.746 132.038 129.571 130.971 130.395 129.905 131.16 128.956 131.16 117.575 130.16ZM124.747 122.861C124.747 121.684 120.302 78.6587 120.124 78.1291 120.006 77.8348 104.002 61.8256 84.3823 42.5792L48.8181 7.49976 27.954 28.2175 7.0302 48.9946 17.6403 59.5299C23.5085 65.357 39.5121 81.1898 53.3822 94.7861L78.4547 119.506 100.623 121.507C112.833 122.626 123.206 123.567 123.74 123.567 124.57 123.567 124.747 123.391 124.747 122.861Z",
    fill: "#5E5E5E",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 2822 1927)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0264 34.4754C0.797833 31.753-4.90472 18.437 0.562754 7.60656 5.50085-2.21769 20.4921-4.11165 28.8986 3.9964 32.3673 7.31065 34.1313 11.276 34.4252 16.4246 34.9543 25.3611 30.0743 32.3448 21.844 34.4754 19.3752 35.0672 14.731 35.0672 12.0264 34.4754ZM21.0799 27.5513C23.2552 26.6044 25.9007 24.0001 26.8999 21.8694 28.0167 19.4429 28.1933 17.4901 27.6054 15.1228 26.018 8.9676 19.6102 4.46971 14.1431 5.65334 10.6155 6.36367 6.85282 9.73718 5.61857 13.1103 4.91297 15.1817 4.97183 17.9045 5.85364 20.2125 7.08826 23.5268 11.2623 27.2554 14.7895 28.202 16.3181 28.6757 19.3752 28.3206 21.0799 27.5513Z",
    fill: "#5E5E5E",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 2896 1854)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1892 85.7341C17.0714 85.6159 16.9535 83.7862 16.9535 81.6613 16.9535 77.2937 17.4246 77.8249 13.0684 77.1756 6.88763 76.2311 1.64878 71.4503-0.588284 64.7218-1.76557 61.1801-1.88308 55.573-0.882605 52.6219 1.64878 45.2442 6.18111 41.1123 13.9513 39.2825L16.9535 38.5154 16.9535 24.35 16.9535 10.1253 16.0116 10.1253C13.4216 10.1253 9.30114 12.2502 6.12254 15.1422L4.65093 16.5586 1.9431 14.3159-0.764733 12.0141 1.70771 9.71198C5.82821 5.81645 10.4195 3.51466 14.8932 3.10172L17.0124 2.92444 17.0124 0.976856 17.0124-1.03018 20.6032-1.03018 24.194-1.03018 24.194 1.44889 24.194 3.86887 26.6665 4.99022C35.3193 8.88575 40.441 17.0901 40.441 27.0648 40.441 32.7901 39.0873 36.6856 36.0258 39.7549 33.6712 42.1158 31.0224 43.2962 25.1359 44.5948L24.194 44.7718 24.194 56.8717 24.194 68.9712 25.2538 68.381C25.8424 68.0859 27.0197 67.1418 27.9027 66.3152 28.7857 65.489 29.6097 64.8396 29.7272 64.8396 30.0215 64.8396 35.3782 68.2632 35.3782 68.4992 35.3782 68.6174 34.9075 69.2663 34.3778 69.9747 32.9062 71.8045 29.5507 74.2835 26.6665 75.6409L24.194 76.8214 24.194 81.3662 24.194 85.9701 20.8975 85.9701C18.8962 85.9701 17.2478 85.852 17.1892 85.7341ZM16.9535 58.229 16.9535 45.7753 15.8941 46.0113C10.4784 47.1917 7.65272 49.6117 6.12254 54.3926 5.23957 57.2259 5.18063 61.0032 6.00466 63.4823 7.18195 67.0827 10.7138 69.7978 15.0111 70.3289 16.0116 70.4468 16.8949 70.624 16.9535 70.624 16.8949 70.624 16.9535 65.0169 16.9535 58.229ZM28.4324 36.2727C29.2564 35.9185 30.3748 35.21 30.8459 34.6789 32.9647 32.6131 34.0245 27.655 33.1415 23.5825 32.6118 20.9265 30.728 17.267 28.7857 15.1422 27.1962 13.4306 24.8416 11.4239 24.253 11.4239 24.1351 11.4239 23.9586 17.267 23.9586 24.4088L23.9586 37.394 25.3713 37.158C26.2543 37.0398 27.6084 36.6265 28.4324 36.2727Z",
    fill: "#5E5E5E",
    fillRule: "evenodd",
    transform: "matrix(1 0 0 -1 2932 1950)"
  }), /*#__PURE__*/React.createElement("text", {
    fill: "#1930AB",
    fontFamily: "Calibri,Calibri_MSFontService,sans-serif",
    fontWeight: 700,
    fontSize: 83,
    transform: "matrix(1 0 0 1 955.844 751)"
  }, "Distinct news Categories ", /*#__PURE__*/React.createElement("tspan", {
    fontSize: 83,
    x: 857.083,
    y: 0
  }, "\u2013"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 917.24,
    y: 0
  }, "easy to access "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 0,
    y: 99
  }, "and analyze"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 83,
    x: 0,
    y: 226
  }, "Bullish news : "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 486.406,
    y: 226
  }, "news that is "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 917.24,
    y: 226
  }, "likey"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 1095.99,
    y: 226
  }, "to move up "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 0,
    y: 325
  }, "coffee prices"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 83,
    x: 0,
    y: 451
  }, "Bearish"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 83,
    x: 273.281,
    y: 451
  }, "News"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 83,
    x: 481.823,
    y: 451
  }, ":"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 523.646,
    y: 451
  }, "news"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 721.875,
    y: 451
  }, "that"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 882.865,
    y: 451
  }, "is"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 954.479,
    y: 451
  }, "likely"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 1153.28,
    y: 451
  }, "to"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 1244.95,
    y: 451
  }, "mo"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 1356.09,
    y: 451
  }, "ve "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 0,
    y: 550
  }, "down coffee prices"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#01B4F0",
    fontSize: 83,
    x: 2490.2,
    y: 980
  }, "Local Price : "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 2913.01,
    y: 980
  }, "Get local market prices of "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 2490.2,
    y: 1079
  }, "different coffee varieties in the major "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 2490.2,
    y: 1178
  }, "producing "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 2852.28,
    y: 1178
  }, "contries"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#01B4F0",
    fontSize: 83,
    x: 1834.26,
    y: 1671
  }, "Local Weather : "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 2388.27,
    y: 1671
  }, "Overall forecast and "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 1834.26,
    y: 1770
  }, "contributing weather data such as "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 1834.26,
    y: 1869
  }, "Temperature, Humidity, Precipitation, Wind, "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 1834.26,
    y: 1968
  }, "etc. covering all major coffee producing "), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3B3838",
    fontSize: 83,
    x: 1834.26,
    y: 2067
  }, "countries")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeepulsemid);
export default __webpack_public_path__ + "static/media/coffeepulsemid.d5afc34ebda09c1d53145611f2c31f31.svg";
export { ForwardRef as ReactComponent };